import React from "react";
import {
  ToastContainer,
  toast
} from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import signup_bg from "../../assets/img/login_bg.jpg";
import logo from "../../assets/img/logo.svg";
import Loading from "react-fullscreen-loading";
import { showToast } from "../../util/toastHelper";
import { RESET_PASSWOED } from "../../action/apiPath";
import { CallWithOutAuth } from "../../action/apiActions";
import { errorMessageCreate } from "../../util/custom";

export const ResetPassword = () => {
  const location = useLocation();
  // const { token } = useParams();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({
    password: "",
    confirmPassword: "",
  });
  const [formErrors, setFormErrors] = React.useState({
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const passwordStrengthRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;


  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (!token) navigate("/");
  }, []);

  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.password) {
        errors.password = "* Password is required.";
      } else if (formData.password.length < 8) {
        errors.password = ("* Password must be at least 8 characters long.");
    } else if (!passwordStrengthRegex.test(formData.password)) {
        errors.password =
          "* Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.";
      }
  

    if (!formData.confirmPassword) {
      errors.confirmPassword = "* Confirm password is required.";
    } else if (formData.confirmPassword !== formData.password) {
      errors.confirmPassword = "* Passwords do not match.";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);    
    try {
      const res = await CallWithOutAuth("POST", RESET_PASSWOED, {
        newPassword: formData?.confirmPassword,
        token: token
      });
      // console.log(res);
      if (res?.res?.data?.statusCode === 200) {
        showToast("success", errorMessageCreate(res?.res?.data?.message));
        // authDetail.newnewPassword = "";
        setTimeout(() => {
          navigate("/login");
        },2000)

      } else {
        showToast("error", errorMessageCreate(res?.res?.data?.message));
        setTimeout(() => {
          navigate("/forget-password");
        },2000)
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };


  return (
    <>
      {isLoading && (
        <Loading
          loading
          background="rgba(236, 240, 241, 0.7)"
          loaderColor="#3498db"
        />
      )}

      <section className="login_signup_wrapper">
        <div className="img_colm">
          <div className="back_btn" onClick={() => navigate("/")}>
            <i className="fa-solid fa-chevron-left"></i>
          </div>
          <div className="img_block">
            <img src={signup_bg} alt="" />
          </div>
        </div>

        <div className="form_colm">
          <div className="inner_block">
            <img src={logo} alt="" className="logo_img" />
            <h1>Reset Password</h1>
            <p>Please set a new password to continue.</p>

            <form onSubmit={handleSubmit} className="form_block">
              {/* Password */}
              <div className="form_field">
                <div className="input_grp" style={{ position: "relative" }}>
                  <label htmlFor="password">New Password</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "38px",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {/* <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i> */}
                    <i className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>

                  </span>
                </div>
                <span className="red_error">{formErrors.password}</span>
              </div>

              {/* Confirm Password */}
              <div className="form_field">
                <div className="input_grp" style={{ position: "relative" }}>
                  <label htmlFor="confirmPassword">Confirm Password</label>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "38px",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {/* <i className={`fa-solid ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}></i> */}
                    <i className={`fa-solid ${showConfirmPassword ? "fa-eye" : "fa-eye-slash"}`}></i>

                  </span>
                </div>
                <span className="red_error">{formErrors.confirmPassword}</span>
              </div>

              <div className="btn_block">
                <button type="submit">Reset Password</button>
              </div>

              <p>
                Don’t have any account?
                <Link to={"/signup"}> &nbsp; Sign Up</Link>
              </p>
            </form>
          </div>
        </div>
      </section>

      <ToastContainer />
    </>
  );
};

export default ResetPassword;
